import { Card } from '../../components/home/card';

const LAST_UPDATED = 'February 9, 2026';

export function TermsRoute() {
    return (
        <div className="mx-auto w-full max-w-3xl">
            <Card className="animate-fade-up">
                <header className="space-y-3">
                    <p className="text-xs font-semibold uppercase tracking-[0.35em] text-secondary">Legal</p>
                    <h1 className="text-3xl font-semibold leading-tight text-foreground md:text-4xl">Terms of Service</h1>
                    <p className="text-xs text-secondary">
                        Last updated: <span className="font-semibold text-foreground/80">{LAST_UPDATED}</span>
                    </p>
                </header>

                <div className="mt-6 space-y-6 text-sm leading-relaxed text-secondary">
                    <p>
                        These Terms of Service govern your use of unvox.ai (the &quot;Service&quot;). By using the Service, you
                        agree to these Terms.
                    </p>

                    <section className="space-y-2">
                        <h2 className="text-base font-semibold tracking-tight text-foreground">What We Provide</h2>
                        <p>
                            UNVOX generates an instrumental output from audio you upload or a YouTube URL you provide. The
                            Service includes a short preview and (after payment) a full download.
                        </p>
                    </section>

                    <section className="space-y-2">
                        <h2 className="text-base font-semibold tracking-tight text-foreground">Your Content</h2>
                        <p>
                            You are responsible for the content you submit and for ensuring you have the rights and permissions
                            needed to process it. Do not use the Service to violate copyright or other laws.
                        </p>
                    </section>

                    <section className="space-y-2">
                        <h2 className="text-base font-semibold tracking-tight text-foreground">Availability and Limitations</h2>
                        <p>
                            The Service may be unavailable or fail for technical reasons. Outputs may vary in quality and are
                            provided &quot;as is&quot; without warranties.
                        </p>
                    </section>

                    <section className="space-y-2">
                        <h2 className="text-base font-semibold tracking-tight text-foreground">Contact</h2>
                        <p>
                            For support or refund requests, see the Support and Refund pages linked in the footer. Please include
                            your job ID when contacting us.
                        </p>
                    </section>
                </div>
            </Card>
        </div>
    );
}

